import { computed } from 'vue'
import type { ImportErrors } from '@/composables/useGIDataSpeckleImport'

export function useImportWarnings(getErrors: () => ImportErrors) {
  function summarizeError(code: string, count: number) {
    const plural = count === 1 ? '' : 's'
    if (code === 'missing_geology_code') {
      return `${count} borehole${plural} skipped — no geology code set on one or more soil layers:`
    }
    if (code === 'import_failed') {
      return `${count} location${plural} could not be  imported:`
    }
    return `${count} location${plural} (${code}):`
  }

  const warningGroups = computed(() =>
    Object.entries(getErrors()).map(([code, ids]) => ({
      code,
      summary: summarizeError(code, ids.length),
      detail: ids.join(', ')
    }))
  )

  return { warningGroups }
}
